import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { DateFormField, Icon, InputFormField } from '../../../../components';

const eventHandler = (handler) => (e) => handler(e.target.name, e.target.value);

const dateHandler = (fieldName, handler) => (e) => handler(fieldName, new Date(e))

const SetTask = ({ task, onTaskEdited, stepForward, onSetTask, taskEditing, stepTo, reviewing }) => (
  <div id='set-task'>
    <form className='boxed'>
      <Row>
        <Col xs={12}>
          <h2>Task Details</h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Col xs={12} md={4} className='top-gap-sm' id='name-input'>
          <InputFormField {...{
            id: 'name',
            label: 'Name',
            onChange: eventHandler(onTaskEdited),
            value: task.name.value || '',
            validation: task.validation && task.name.validation
          }} />
        </Col>
        <Col xs={12} md={4} id='due-date-input'>
          <DateFormField {...{
            onChange: dateHandler('dueDate', onTaskEdited),
            dateProps: {
              labels: {
                day: 'Due Day'
              },
              minYear: (new Date()).getFullYear(),
              futureYears: 5
            },
            validation: task.validation && task.dueDate.validation,
            value: task.dueDate.value
          }} />
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Col xs={8} id='description-input'>
          <InputFormField {...{
            id: 'description',
            label: 'Description',
            onChange: eventHandler(onTaskEdited),
            value: task.description.value || '',
            validation: task.validation && task.description.validation
          }} />
        </Col>
        <Col xs={4}>
          {
            (taskEditing || reviewing) ?
              <Button className='pull-right top-gap' onClick={() => stepTo(3)}>Review<Icon className='left-gap' icon='chevron-right-large' /></Button> :
              <Button className='pull-right top-gap' onClick={onSetTask}>Set Content<Icon className='left-gap' icon='chevron-right-large' /></Button>
          }
        </Col>
      </Row>
    </form>
  </div>
)

const mapStateToProps = (state) => ({})
const mapDispatchToProps = (dispatch) => ({})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSetTask: ({ task, stepForward, onTaskSubmitted }) => () => {
      const validation = onTaskSubmitted()
      if (!validation) {
        stepForward()
      }
    }
  })
)(SetTask)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/set-task.js